import { useLocation, useNavigate, useParams } from 'react-router'

import Tabs from '@/components/_legacy/Tabs'

const tabs = [
  {
    label: 'Settings',
    value: 'settings'
  },
  {
    label: 'Actions',
    value: 'actions'
  }
]

const EventSettingsTabs = ({ selectedTab }: { selectedTab: 'actions' | 'settings' }) => {
  const navigate = useNavigate()
  const searchParams = useParams()
  const location = useLocation()
  const pathname = location.pathname

  const onTabChange = (tab: string) => {
    if (tab !== selectedTab) {
      const params = new URLSearchParams(searchParams?.toString())
      params.set('settings-tab', tab)
      navigate(pathname + '?' + params.toString())
    }
  }

  return (
    <Tabs
      selectedTabValue={selectedTab}
      tabs={tabs}
      onChange={onTabChange}
      containerStyle={{ background: 'white' }}
    />
  )
}

export default EventSettingsTabs
